import { render, staticRenderFns } from "./MatterSubmit.vue?vue&type=template&id=1c712aea&scoped=true&"
import script from "./MatterSubmit.vue?vue&type=script&lang=js&"
export * from "./MatterSubmit.vue?vue&type=script&lang=js&"
import style0 from "./MatterSubmit.vue?vue&type=style&index=0&id=1c712aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c712aea",
  null
  
)

export default component.exports